import {Component, OnInit} from '@angular/core';
import {Chunker} from '../framework/chunker';
import {FrameworkHttpService} from '../framework/http/service';


import {Injectable} from '@angular/core';
import {
	AnomalyEntity,
	AnomalyResult, AutoReconciliationRow,
	QARService, SORUserEntity,
	SystemEntity,
	SystemRole2GroupEntity,
	SystemRoleEntity,
	SystemRoleGroupEntity
} from '../services/qar.service';
import {UITableComponentHeader} from '../framework/ui/table';

@Component({
	selector: 'app-page-user-roles-auto-rec',
	templateUrl: './user-roles-auto-rec.html',
	providers: [QARService]
})
export class UserRolesAutoRecPageComponent implements OnInit {

	constructor(public apiQAR: QARService) {

	}

	ngOnInit(): void {
		this.roles_init();
		this.groups_init();
		this.systems_init();
	}

	public helper_asInt(w) {
		return parseInt(w, 0);
	}

	public groups = {
		data: [] as SystemRoleGroupEntity[],
		loading: false,
		byId: {},
		modalIsHidden: true,
		userRoles: {},
		user: {},
		userSaving: false
	};

	groups_init() {
		this.groups.loading = true;
		this.groups.byId = {};
		this.apiQAR.retrieveAllRoleGroups().then(r => {
			this.groups.loading = false;
			this.groups.data = r;
			for (const ag of r) {
				this.groups.byId[parseInt(ag.Id, 0)] = ag;
			}
		});
	}

	public groups_selectForUser(r) {

		this.groups.modalIsHidden = false;
		this.groups.userRoles = {};
		this.groups.user = r;
		for (const id of r.ActualRolesIds) {
			this.groups.userRoles[id] = true;
		}
	}

	public groups_saveSelectionForUser() {
		this.groups.userSaving = true;

		this.groups.user['ActualRolesNames'] = [];
		this.groups.user['ActualRolesIds'] = [];
		const roles = [];
		for (const id in this.groups.userRoles) {
			if (this.groups.userRoles[id]) {
				roles.push(id);
				this.groups.user['ActualRolesIds'].push(id);
				this.groups.user['ActualRolesNames'].push(this.groups.byId[id].Name);
			}
		}

		this.apiQAR.saveSystemRoleGroupForSORUserId(this.groups.user['User'].Id, roles).then(r => {
			this.groups.modalIsHidden = true;
		}).catch(e => {
			console.error(e);
			alert('could not save!');
		}).finally(() => {
			this.groups.userSaving = false;
		});
	}

	public roles = {
		loading: false,
		saving: false,
		loadingSelected: false,
		assignedGroups: {},
		byId: {},
		selected: new SystemRoleEntity(),
		chunker: new Chunker([]),
		chunkedData: [],
		selectedId: 0,
		tableHeaders: [
			{label: 'System Name', filterable: true, idFunction: this.helper_idfunctionSystemName},
			{id: 'Name', label: 'Role Name', filterable: true},
			{id: 'MappedName', label: 'Standard role Name', filterable: true},
			{label: 'Groups', filterable: true, idFunction: this.helper_idfunctionGroups},
			{label: 'Group Count', filterable: true, idFunction: this.helper_countAssignedGroups}
		] as UITableComponentHeader[]
	};

	public helper_idfunctionGroups(row) {
		const groups = row.AssignedGroups;
		let ret = [];
		for (const ag of groups) {
			ret.push(ag.RoleGroup.Name);
		}
		return ret.join(',');
	}

	public helper_idfunctionSystemName(row) {
		return row.System.Name;
	}

	roles_init() {
		this.roles.loading = true;
		this.apiQAR.retrieveAllRolesWithGroups().then(r => {
			this.roles.loading = false;
			this.roles.chunker = new Chunker(r);
			this.roles.byId = {};
			for (const row of r) {
				this.roles.byId[row.Id] = row;
			}
		});
	}

	public roles_onRowClick(role) {
		console.log('roles_onRowClick', role);
		this.roles.selectedId = role.Id;
		this.roles.selected = new SystemRoleEntity();
		this.roles.loadingSelected = true;
		this.roles.assignedGroups = [];
		this.apiQAR.retrieveRoleWithGroups(role.Id).then(r => {
			this.roles.loadingSelected = false;
			this.roles.selected = r;
			for (const g of r.AssignedGroups) {
				this.roles.assignedGroups[parseInt(g.SystemRoleGroupId, 0)] = true;
			}
		});
	}

	public role_save() {
		this.roles.saving = true;
		const groupIds = [];
		for (const id in this.roles.assignedGroups) {
			if (this.roles.assignedGroups[id]) {
				groupIds.push(id);
			}
		}
		this.apiQAR.saveRoleGroups(this.roles.selectedId, {SystemRoleGroupIds: groupIds}).then(updated => {
			this.roles_onRowClick(this.roles.selected);
			this.roles.saving = true;
			// update chunker
			for (let r of this.roles.chunkedData) {
				if (r.Id == this.roles.selectedId) {
					r.AssignedGroups = updated.AssignedGroups;
				}
			}
		});
	}

	public rec = {
		loading: false,
		done: false,
		selected: new AutoReconciliationRow(),
		chunker: new Chunker([]),
		chunkedData: [],
		tableHeaders: [],
		modalHidden: true
	};

	public rec_start() {
		this.rec.tableHeaders = [
			{label: 'User', filterable: true, idFunction: this.rec_idFunctionUser, id: 'user'},
			{label: 'Actual Roles', filterable: true, idFunction: this.rec_idFunctionActualRoles},
			{label: 'Title', filterable: true, idFunction: this.rec_idFunctionTitle},
			{label: 'Role Count', filterable: true, idFunction: this.rec_idFunctionRoleCount},
		];
		for (const g of this.groups.data) {
			this.rec.tableHeaders.push({label: g.Name, id: g.Id, filterable: true, idFunction: this.rec_idFunctionGroup});
		}

		this.rec.tableHeaders.push({
			label: 'Suspect?', filterable: true, idFunction: this.rec_isRowSuspect, type: 'dropdown', options: {
				choices: {
					roles: 'Roles mismatch',
					no_roles_assigned: 'No role assigned',
					'': 'No',
				}
			},
			id: 'rolesrec'
		});

		this.rec.loading = true;
		this.rec.done = false;
		this.apiQAR.userRolesAutoReconciliationStart(this.systems.selectedId).then(r => {
			this.rec.loading = false;
			this.rec.done = true;
			this.rec.chunker = new Chunker(r);

			setTimeout(() => {
				this.rec.tableHeaders[this.rec.tableHeaders.length - 1].filterValue = 'roles';
			}, 100);
		});
	}

	public rec_idFunctionActualRoles(row, a) {
		console.log('rec_idFunctionActualRoles',row);
		return row.ActualRolesIds && row.ActualRolesIds.length ? row.ActualRolesNames.join(',') : 'no role';
	}

	public rec_idFunctionGroup(row, a) {
		return row.GroupIdCount[a] ? row.GroupIdCount[a] : 0;
	}

	public helper_countAssignedGroups(row: SystemRoleEntity) {
		return row.AssignedGroups.length;
	}

	public rec_idFunctionUser(row: AutoReconciliationRow) {
		return row.User.FirstName + ' ' + row.User.LastName;
	}

	public rec_idFunctionTitle(row: AutoReconciliationRow) {
		return row.User.Title;
	}

	public rec_idFunctionRoleCount(row: AutoReconciliationRow) {
		return row.RoleIds.length;
	}

	public rec_details(r) {
		this.rec.modalHidden = false;
		this.rec.selected = r;
	}

	public rec_isRowSuspect(row) {
		if (row.ActualRolesIds && row.ActualRolesIds.length > 0) {
			if (row.RolesWithIssue && row.RolesWithIssue.length) {
				return 'roles';
			}
			return '';
		}
		let howMany = 0;
		for (let r in row.GroupIdCount) {
			howMany++;
		}
		return howMany > 1 ? 'no_roles_assigned' : '';
	}

	public rec_userHasRole(roleId, name) {
		if (name === 'Other') {
			return true;
		}
		return this.rec.selected.ActualRolesIds && this.rec.selected.ActualRolesIds.indexOf(roleId) !== -1;
	}

	public systems = {
		loading: false,
		selectedId: 0,
		data: [] as SystemEntity[]
	};

	public systems_init() {
		this.systems.loading = true;
		this.apiQAR.retrieveSystems().then(r => {
			this.systems.loading = false;
			this.systems.data = r;
		});
	}


}
